import { RestChatService } from '@repo/network'
import { ComponentMessageMediaVO } from '@repo/types'
import { GenericAbortSignal } from 'axios'
import { useCallback } from 'react'

export const useSendMediaToServer = () => {
  const uploadMedias = useCallback(
    async (files: FileList, connectionKey: string, signal?: GenericAbortSignal): Promise<ComponentMessageMediaVO[]> => {
      const medias: ComponentMessageMediaVO[] = []
      for (let i = 0; i < files.length; i++) {
        const formData = new FormData()
        formData.append('file', files[i])
        const media = await RestChatService.uploadMedia(formData, connectionKey, signal)
        medias.push(media)
      }
      return medias
    },
    []
  )

  return {
    uploadMedias
  }
}
